import { inject, Injectable } from '@angular/core';
import { formatAmount } from '../helpers/amount.helper';
import { WINDOW, WindowRef } from './window.service';

export interface BaremeValeurAssureeElement {
  Id: number;
  NombrePieces: number;
  F1: number;
  F2: number;
}

export type BaremeValeurAssuree = BaremeValeurAssureeElement[];

export type Countries = string[];

export interface BailleurElement {
  Id: number;
  Email: string;
  Name: string;
}

export type Bailleurs = BailleurElement[];
export type Assureurs = AssureurElement[];

export interface AssureurElement {
  Id: number;
  NomAssureur: string;
  AdressePostale: string;
  CodePostal: string;
  Ville: string;
}

export interface BaremeDataWithObjectValue {
  pieceNumber: string;
  ct1Label: string;
  ct1: boolean;
  ct2: boolean;
  value: number;
  ct2Label: string;
  objectValue?: number;
}
@Injectable({
  providedIn: 'root'
})
export class ReferenceDataService {
  private windowRef = inject<WindowRef>(WINDOW);

  constructor() {}
  get baremeValeurAssuree(): BaremeValeurAssuree {
    return (this.windowRef as any).vyvBaremeValeurAssuree;
  }

  getBaremeForMRHMetropoleAltima(): BaremeDataWithObjectValue[] {
    // TODO: to dynamize with the backend later
    // BAREME MRH GRENOBLE CRETEIL
    const arrayMetropole = [
      {
        pieceNumber: '1',
        value: 10000,
        objectValue: 2000
      },
      {
        pieceNumber: '2',
        value: 10000,
        objectValue: 2000
      },
      {
        pieceNumber: '3',
        value: 15000,
        objectValue: 3000
      },
      {
        pieceNumber: '4',
        value: 20000,
        objectValue: 4000
      },
      {
        pieceNumber: '5',
        value: 20000,
        objectValue: 4000
      },
      {
        pieceNumber: '6',
        value: 20000,
        objectValue: 4000
      },
      {
        pieceNumber: '7',
        value: 20000,
        objectValue: 4000
      },
      {
        pieceNumber: '8',
        value: 20000,
        objectValue: 4000
      }
    ];
    return arrayMetropole.map(bareme => {
      return {
        pieceNumber: bareme.pieceNumber,
        ct1Label: `Jusqu'à ${formatAmount(bareme.value)}`,
        ct1: false,
        ct2: false,
        value: bareme.value,
        ct2Label: `Au-delà de ${formatAmount(bareme.value)}`,
        objectValue: bareme.objectValue
      };
    });
  }

  getBaremeForMRHEtudiant(): BaremeDataWithObjectValue[] {
    // BAREME ETUDIANT
    const arrayStudent = [
      {
        pieceNumber: 'CHA_U',
        value: 2300
      },
      {
        pieceNumber: 'CHA_HAB',
        value: 3900
      },
      {
        pieceNumber: '1',
        value: 3900
      },
      {
        pieceNumber: '2',
        value: 5400
      },
      {
        pieceNumber: '3',
        value: 7000
      },
      {
        pieceNumber: '4',
        value: 12200
      },
      {
        pieceNumber: '5',
        value: 12200
      }
    ];
    return arrayStudent.map(bareme => {
      return {
        pieceNumber: bareme.pieceNumber,
        ct1Label: `Jusqu'à ${formatAmount(bareme.value)}`,
        ct1: false,
        ct2: false,
        value: bareme.value,
        ct2Label: `Au delà de ${formatAmount(bareme.value)}`
      };
    });
  }
}
